import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Input, Button, Typography, message, Card } from 'antd';
import { PhoneOutlined, LockOutlined, ArrowLeftOutlined, FlagOutlined } from '@ant-design/icons';
import { ambassadorService } from '../../common/services/api';
import './AmbassadorPage.css';

const { Title, Text, Paragraph } = Typography;

const AmbassadorLoginPage = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await ambassadorService.login(values.phone, values.password);
            if (response.success) {
                localStorage.setItem('ambassadorToken', response.data.accessToken);
                localStorage.setItem('ambassadorUser', JSON.stringify(response.data));
                message.success('Connexion reussie !');
                navigate('/ambassadeurs/dashboard');
            } else {
                message.error(response.message || 'Erreur de connexion');
            }
        } catch (error) {
            message.error(error.message || 'Erreur de connexion');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ambassador-login-page">
            <div className="login-container">
                <Link to="/ambassadeurs" className="login-back-link" style={{ color: '#fff' }}>
                    <ArrowLeftOutlined /> Retour au programme
                </Link>

                <Card className="login-card" bodyStyle={{ padding: '40px' }}>
                    <div className="login-header">
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            color: '#D4A853',
                            marginBottom: 16
                        }}>
                            <FlagOutlined style={{ fontSize: 24 }} />
                            <Text strong style={{ color: '#D4A853' }}>Brand Ambassador</Text>
                        </div>
                        <Title level={2}>Connexion</Title>
                        <Paragraph type="secondary">
                            Accedez a votre espace ambassadeur
                        </Paragraph>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={false}
                    >
                        <Form.Item
                            name="phone"
                            label="Telephone"
                            rules={[
                                { required: true, message: 'Veuillez entrer votre telephone' },
                                { pattern: /^[0-9+]{8,15}$/, message: 'Numero invalide' }
                            ]}
                        >
                            <Input
                                prefix={<PhoneOutlined />}
                                placeholder="Ex: 0700000000"
                                size="large"
                                onChange={(e) => {
                                    // Supprimer les espaces automatiquement
                                    const cleanValue = e.target.value.replace(/\s/g, '');
                                    form.setFieldValue('phone', cleanValue);
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label="Mot de passe"
                            rules={[{ required: true, message: 'Veuillez entrer votre mot de passe' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Mot de passe"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                block
                                loading={loading}
                            >
                                Se connecter
                            </Button>
                        </Form.Item>
                    </Form>

                    <div className="login-footer">
                        <Text>
                            Pas encore ambassadeur ?{' '}
                            <Link to="/ambassadeurs/inscription" style={{ color: '#D4A853' }}>
                                S'inscrire
                            </Link>
                        </Text>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default AmbassadorLoginPage;
